const DEFAULT_SHARE_BRANDING = Object.freeze({
  siteName: "Sproutly",
  fallbackImagePath: "/icons/icon-512.png",
  faviconPath: "/icons/icon-192.png",
  touchIconPath: "/icons/icon-192.png",
});

export function getShareBranding(portal) {
  if (!portal || portal.unavailable) return DEFAULT_SHARE_BRANDING;

  return {
    siteName: String(portal.name || portal.browserBranding?.title || "Sproutly"),
    fallbackImagePath: String(
      portal.branding?.logoUrl || portal.browserBranding?.appIcon512Path || "/icons/icon-512.png"
    ),
    faviconPath: String(portal.browserBranding?.faviconPath || "/icons/icon-192.png"),
    touchIconPath: String(
      portal.branding?.logoUrl || portal.browserBranding?.appIcon192Path || "/icons/icon-192.png"
    ),
  };
}

export function shareTitle(subject, branding = DEFAULT_SHARE_BRANDING) {
  return `${subject} on ${branding.siteName}`;
}

export function shareAttribution(subject, branding = DEFAULT_SHARE_BRANDING) {
  return `${subject} on ${branding.siteName}`;
}
